<template>
  <div id="app">
    <router-view :key="key" />
  </div>
</template>
<script src="../../js/flexible.js"></script>
<script>
export default {
  name: "App",

  computed: {
    key() {
      return this.$route.path;
    },
  },
  created() {
    if (location.href.indexOf("course") > -1) {
      document.getElementsByTagName("title")[0].innerText = "课题系统";
    }
  },
  methods: {
    w() {
      var r = document.documentElement;
      var a = r.getBoundingClientRect().width; //获取当前设备的宽度
      if (a > 720) {
        //720不固定，根据设计稿的宽度定
        a = 720;
      }
      rem = a / 7.2;
      r.style.fontSize = rem + "px";
    },
  },
};
</script>
<style>
body,
html {
  /* background-color: rgb(245, 245, 245); */
  font-size: 15px !important;
}
.reviewer-from .vue-treeselect__control {
  border: none;
}
.reviewer-from .vue-treeselect__single-value {
  line-height: 44px;
}
.vue-treeselect__menu-container {
  z-index: 100001 !important;
}
/* .w-e-toolbar,
.w-e-text-container {
  z-index: 0 !important;
} */
.designee .el-form-item__content {
  line-height: 38px;
}
</style>
